// ugs_web JS bundle

import Awesomplete from "awesomplete";
import './ugs_web.js';
import './ugs_filter_sidebar.js';
import './ugs_web_cart.js';
